import React from 'react';
import { Spinner } from '../../../../flayr-components/Spinner/Spinner';

interface ILoadingStepProps {}

const LoadingStep: React.FC<React.PropsWithChildren<React.PropsWithChildren<ILoadingStepProps>>> = ({}) => {
  return (
    <div className="my-8">
      <Spinner showing className="text-lg" />

      <div className="mt-4 text-2xl text-center">Cancelling booking</div>
    </div>
  );
};
export default LoadingStep;
